import { type CityProfile } from '@core/city-profile/city-profile'

// the Paris demo profile — sixth demo city alongside Lyon, Lisbon, Torino, Mexico City and Puebla.
// centre is the Île de la Cité / Châtelet axis, the historical kilometre zero of the capital ;
// like Lyon the UI runs in FRENCH, so this build needs no translation pass at all.
// the dataset covers the Grand Paris footprint served by Île-de-France Mobilités — from La Défense
// to Marne-la-Vallée and from Saint-Denis to Massy-Saclay — a much wider area than Lyon, hence the
// far looser zoom.
export const kParisProfile: CityProfile = {
  id: 'paris',
  displayName: 'Mobilité Grand Paris',
  brandLines: ['Mobilité', 'Grand Paris'],
  center: [2.3488, 48.8566],
  zoom: 11.2,
  supervisionZoom: 10.8,
  locale: 'fr-fr',
  tz: 'Europe/Paris',
  currency: '€',
}
